import { useStructureContext } from "../../../context/StructureContext";
import { headerRecords } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { stdObject } from "../../../data/types/stdObject";

export default function RecordsBox() {
  const { type, searchValues, section, printArea } = useStructureContext();
  const { openRecordInfo } = useMainContext();

  const filterValues = () => {
    let tempResults = searchValues[section.id].results;
    [
      ["PERHIS", "userCode"],
      ["AREHIS", "type"],
      ["ACNHIS", "observ"],
      ["CODHIS", "code"],
      ["NOMHIS", "name"],
    ].forEach((e) => {
      if (searchValues[section.id][e[0]].value.trim() !== "") {
        tempResults = tempResults.filter((o: stdObject) =>
          e[1] in o && ["string", "number"].includes(typeof o[e[1]])
            ? ["CODHIS", "NOMHIS"].includes(e[0])
              ? typeof o[e[1]] === "string" &&
                o[e[1]]
                  .toLowerCase()
                  .toString()
                  .includes(
                    searchValues[section.id][e[0]].value.trim().toLowerCase(),
                  )
              : o[e[1]].toString() === searchValues[section.id][e[0]].value
            : searchValues[section.id][e[0]].value === "undefined" && !o[e[1]],
        );
      }
    });
    return tempResults;
  };

  return "FECHIS" in searchValues[section.id] ? (
    <div ref={printArea} className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerRecords}
        data={
          "results" in searchValues[section.id] &&
          Array.isArray(searchValues[section.id].results)
            ? filterValues()
            : []
        }
        onDoubleClick={openRecordInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
